export default function initCookieModal(): void {
  const button = document.getElementById('cookie-policy-btn') as HTMLButtonElement | null
  const dialog = document.getElementById('cookie-dialog') as HTMLDialogElement | null

  if (!button || !dialog) {
    return
  }

  button.addEventListener('click', () => {
    dialog.showModal()
  })

  dialog.addEventListener('click', (e: MouseEvent) => {
    if (e.target === dialog) {
      dialog.close()
    }
  })

  const closeBtn = dialog.querySelector('[data-dialog-close]') as HTMLButtonElement | null
  closeBtn?.addEventListener('click', () => {
    dialog.close()
  })
}
